import { FC } from "react";
import {
  AppBar,
  Box,
  Chip,
  Divider,
  IconButton,
  Toolbar,
  Typography
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "./logo.svg?react";
import { User } from "../../components/user";
import { getRuntimeConfig } from "../../runtimeConfig/runtime-config";
import { darkSurfaces, useThemeMode } from "../../theme";
import { ThemeSwitch } from "../../components/themeSwitch";
import GitInfo from "../../generatedGitInfo.json";
import { useIsMobileLayout } from "../useIsMobileLayout";
import { MobileAccountMenu } from "./mobileAccountMenu";
import { TechnoLogo } from "../../components/technoMode/technoLogo";

const isDevOrTest = getRuntimeConfig().PUBLIC_IS_TEST_ENV;

type Props = {
  /** Opens the nav drawer. Only rendered below md, where the nav rail is hidden. */
  onOpenNav: () => void;
};

export const Topbar: FC<Props> = ({ onOpenNav }) => {
  const { mode, toggleTheme, techno } = useThemeMode();
  const isMobile = useIsMobileLayout();

  return (
    <AppBar
      className="ma-topbar"
      position="static"
      elevation={0}
      sx={{
        background: (theme) =>
          theme.palette.mode === "dark"
            ? darkSurfaces.chrome
            : theme.palette.primary.dark,
        borderBottom: (theme) =>
          theme.palette.mode === "dark"
            ? `1px solid ${darkSurfaces.border}`
            : "none"
      }}
    >
      <Toolbar
        variant="regular"
        sx={{
          zIndex: 1,
          boxShadow: (theme) =>
            theme.palette.mode === "dark"
              ? "none"
              : "0px 2px 4px rgba(0, 0, 0, 0.3)"
        }}
      >
        {isMobile ? (
          <>
            <IconButton
              aria-label="Open navigation"
              edge="start"
              onClick={onOpenNav}
              sx={{ marginRight: 1 }}
            >
              <MenuIcon
                sx={{ color: (theme) => theme.palette.MFT_OFF_WHITE }}
              />
            </IconButton>
            <Typography
              variant="subtitle1"
              color="MFT_OFF_WHITE"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              Market Access Hub
            </Typography>
            {isDevOrTest && (
              <Chip
                size="small"
                label="TEST ENV"
                color="warning"
                sx={{ marginRight: 1 }}
              />
            )}
            <MobileAccountMenu />
          </>
        ) : (
          <>
            {techno ? (
              <TechnoLogo>
                <Logo height="64px" />
              </TechnoLogo>
            ) : (
              <Logo height="64px" />
            )}
            <Box
              sx={{
                flexGrow: 1,
                textAlign: "center",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis"
              }}
            >
              <Typography variant="h5" color="MFT_OFF_WHITE">
                Market Access Hub
              </Typography>
              {isDevOrTest && (
                <Typography variant="h5" padding={4} color="MFT_OFF_WHITE">
                  🚧 Test environment 🚧
                </Typography>
              )}
            </Box>
            <ThemeSwitch checked={mode === "dark"} onChange={toggleTheme} />
            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{ marginX: 1, marginY: 2, borderColor: "#7f7f7f" }}
            />

            <User />
            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{ marginX: 1, marginY: 2, borderColor: "#7f7f7f" }}
            />
            <Box>
              <Typography sx={{ fontSize: "10px" }} color="MFT_OFF_WHITE">
                {GitInfo ? "commit: " + GitInfo?.gitCommitHash : ""}
              </Typography>
            </Box>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};
